import { Checkbox, InputClearValue, InputPrefix, TextBox } from '@progress/kendo-react-inputs'
import { Icon } from '@progress/kendo-react-common';
import { Loader } from '@progress/kendo-react-indicators';
import React, { useState } from 'react'
import './Chat.scss'

export default function ChatFilter(props: { onFilterChange(val: FilterProps) }) {
    const [filter, setFilter] = useState<FilterProps>({} as FilterProps)
    return (
        <div className='chat-filter'>
            <TextBox className='chat-search'
                value={filter.search}
                onChange={(e) => {
                    //console.log('onChange')
                    setFilter((prev) => {
                        var newFilter = { ...prev, search: e.value.toString().toLocaleLowerCase() }
                        props.onFilterChange(newFilter);
                        return newFilter;
                    });

                }}
                placeholder="Search..."
                prefix={() => (
                    <InputPrefix>
                        <Icon name="search" />
                    </InputPrefix>)
                }
                suffix={() => (
                    <>
                        {filter.search && (
                            <InputClearValue onClick={() => {
                                setFilter(p => {
                                    var newFilter = { ...p, search: null }
                                    props.onFilterChange(newFilter);
                                    return newFilter;
                                })
                            }}>
                                <Icon name="x" />
                            </InputClearValue>
                        )}
                        {false && <Loader type='pulsing' themeColor='secondary' />}
                    </>
                )}
            />
            <Checkbox checked={filter.closed} onChange={(e) => {
                setFilter((prev) => {
                    var newFilter = { ...prev, closed: e.value }
                    props.onFilterChange(newFilter);
                    return newFilter;
                });
            }} label={'Include closed chats'} />
        </div>
    )
}

export type FilterProps = {
    search: string
    closed: boolean
}